import { useTranslation as e } from "../../i18n.mjs";
import { ToolbarSelect as t } from "../../components/content-controls/toolbar-select.mjs";
import { ToolbarPopover as n } from "../../components/content-controls/toolbar-popover.mjs";
import { SelectedCategoriesEnum as r } from "./selected-categories-enum.mjs";
import { specialCharactersData as i } from "./special-characters-data.mjs";
import { getCharactersCategoriesData as a } from "./get-characters-categories-data.mjs";
import { useEditorState as o } from "@tiptap/react";
import { useMemo as s, useState as c } from "react";
import { Button as l } from "@systemeio/components";
import { Fragment as u, jsx as d, jsxs as f } from "react/jsx-runtime";
import { OmegaIcon as p } from "@systemeio/icons";
//#region src/extensions/special-characters-extension/use-special-characters-extension-toolbar.tsx
var m = (m) => {
	let { t: h } = e(), [g, _] = c(r.All), [v, y] = c(null), b = !o({
		editor: m,
		selector: ({ editor: e }) => ({ isEditable: e?.options.editable ?? !1 })
	})?.isEditable;
	return s(() => {
		let e = (e) => {
			m && m.chain().focus().insertContent(e).run();
		}, r = /* @__PURE__ */ f(u, { children: [
			/* @__PURE__ */ f("div", {
				className: "border-border-100 flex items-center justify-between border-b pb-2",
				children: [/* @__PURE__ */ d("span", {
					className: "text-text-primary tablet:inline hidden text-base",
					children: h("special_characters.title")
				}), /* @__PURE__ */ d(t, {
					label: h("special_characters.title"),
					onChange: _,
					options: a(h),
					value: g,
					children: a(h).find((e) => e.value === g)?.label
				})]
			}),
			/* @__PURE__ */ d("div", {
				className: "flex max-h-45 flex-wrap gap-2 overflow-y-auto py-3",
				children: i[g].map((t, n) => /* @__PURE__ */ d(l, {
					"aria-label": h(t.name),
					onClick: () => e(t.symbol),
					onMouseEnter: () => y(n),
					onMouseLeave: () => y(null),
					size: "icon-xs",
					variant: "ghost-gray",
					children: t.symbol
				}, t.code))
			}),
			/* @__PURE__ */ d("div", {
				className: "flex h-5 items-center justify-between text-xs",
				children: v === null ? null : /* @__PURE__ */ f(u, { children: [/* @__PURE__ */ d("span", { children: h(i[g]?.[v]?.name ?? "") }), /* @__PURE__ */ d("span", { children: i[g]?.[v]?.code })] })
			})
		] }), o = (e) => /* @__PURE__ */ d(n, {
			asSheetRow: e,
			disabled: b,
			icon: /* @__PURE__ */ d(p, {}),
			keepEditorFocus: !0,
			label: h("special_characters.title"),
			popupClassName: "w-80 p-3",
			children: r
		});
		return {
			toolbarRender: o(!1),
			sheetRender: o(!0)
		};
	}, [
		m,
		v,
		b,
		g,
		h
	]);
};
//#endregion
export { m as useSpecialCharactersExtensionToolbar };
